module.exports = __webpack_public_path__ + "img/testimonial-1.a946e36f.jpg";